import {
  REPORTS_ENQUADRAMENTO_REGRAS_CHANGED,
  REPORTS_ENQUADRAMENTOS_CHANGED,
  REPORTS_ENQUADRAMENTO_PARAMS_CHANGED,
  REPORTS_VAR_PARAMS_CHANGED,
  REPORTS_DURATION_PARAMS_CHANGED,
  REPORTS_LOGOUT,
} from "../../const/actionsType";
import { dates } from "investira.sdk";

const INITIAL_STATE = {
  enquadramento: {
    regras: { data: {}, updatedAt: dates.toDate() },
  },
  enquadramentos: { data: {}, updatedAt: dates.toDate() },
  params: {
    enquadramento: {}, // { 2626: { ...params, updatedAt: dates.toDate() } } chave por userid + entidade
    var: {},
    duration: {},
  },
};

function reportsReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REPORTS_ENQUADRAMENTO_REGRAS_CHANGED:
      return {
        ...state,
        enquadramento: {
          ...state.enquadramento,
          regras: {
            data: action.payload,
            updatedAt: dates.toDate(),
          },
        },
      };
    case REPORTS_ENQUADRAMENTOS_CHANGED:
      return {
        ...state,
        enquadramentos: {
          data: action.payload,
          updatedAt: dates.toDate(),
        },
      };
    case REPORTS_ENQUADRAMENTO_PARAMS_CHANGED:
      return {
        ...state,
        params: {
          ...state.params,
          enquadramento: {
            ...state.params.enquadramento,
            [`${action.payload.usuario_id}${action.payload.current_entidade_id}`]:
              action.payload.params,
            updatedAt: dates.toDate(),
          },
        },
      };
    case REPORTS_VAR_PARAMS_CHANGED:
      return {
        ...state,
        params: {
          ...state.params,
          var: {
            ...state.params.var,
            [`${action.payload.usuario_id}${action.payload.current_entidade_id}`]:
              action.payload.params,
            updatedAt: dates.toDate(),
          },
        },
      };
    case REPORTS_DURATION_PARAMS_CHANGED:
      return {
        ...state,
        params: {
          ...state.params,
          duration: {
            ...state.params.duration,
            [`${action.payload.usuario_id}${action.payload.current_entidade_id}`]:
              action.payload.params,
            updatedAt: dates.toDate(),
          },
        },
      };
    case REPORTS_LOGOUT:
      return {
        ...INITIAL_STATE,
      };

    default:
      return state;
  }
}

export default reportsReducer;
